import { render } from "./AgentLeadsView.vue?vue&type=template&id=62938a24&scoped=true"
import script from "./AgentLeadsView.vue?vue&type=script&lang=js"
export * from "./AgentLeadsView.vue?vue&type=script&lang=js"

import "./AgentLeadsView.vue?vue&type=style&index=0&id=62938a24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62938a24"]])

export default __exports__